import React from 'react';
import { Card, Button } from 'react-bootstrap';
import '../../../../assets/css/customer/hotelspages/filter.css';

const Filters = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { value: 'all', label: 'All Hotels', icon: '🏨' },
    { value: '5', label: '5 Star Hotels', },
    { value: '4', label: '4 Star Hotels',  },
    { value: '3', label: '3 Star Hotels',  }
  ];

  return (
    <Card className="cus-htl-filters-card">
      <Card.Body>
        <Card.Title className="cus-htl-filters-title">
          <span className="cus-htl-filter-icon">⭐</span> Filter by Rating
        </Card.Title>
        <div className="cus-htl-filter-buttons-container">
          {filters.map((filter) => (
            <Button
              key={filter.value}
              className={`cus-htl-filter-btn ${activeFilter === filter.value ? 'active' : ''}`}
              onClick={() => onFilterChange(filter.value)}
            >
              <span className="cus-htl-filter-btn-icon">{filter.icon}</span>
              <span className="cus-htl-filter-btn-text">{filter.label}</span>
            </Button>
          ))}
        </div>
        <div className="cus-htl-filters-info">
          <p className="cus-htl-info-text">
            💡 Select a rating to filter hotels by star classification
          </p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Filters;